import { CompanyTypes } from '../enums';

export interface InvoicerCompanyBillingDataModel {
  id: number;
  name: string;
  companyType: CompanyTypes;
}
